import React, { useRef, useState } from "react";
import moment from "moment";
import { kFormatter, percentageFormatter } from "../../Dashboard/Charts/utils";
import { Icon } from "semantic-ui-react";
import DimmerComponent from "../../Dashboard/DimmerComponent";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import { Dropdown } from "semantic-ui-react";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as MoreOptions } from "../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../assets/svg/settings.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/svg/downloads.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/chevron.svg";
import { ReactComponent as MiniMize } from "../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../assets/svg/zoom_out_map.svg";
import ChartOptionsSidebar from "../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../../Dashboard/Charts/ChartFilterOptions";
import ChartName from "../../Dashboard/Charts/ChartName";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle } from "../../Dashboard/Charts/utils";
import FBIntervalSelector from "../FBIntervalSelector";
// import "../../Dashboard/Charts/TotalValueCharts/TotalValueCharts.scss";
import "../../EnhancedInsights/modules/InstagramInsights/components/TotalReach/TotalReach.scss";
import FBPageSelector from "../FBPageSelector";
import UpIcon from "../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../assets/svg/arrow-down.svg";
import Loading from "../../EnhancedInsights/modules/InstagramInsights/components/Loading/Loading";

function TotalFollowersCount(props) {
    const [downloading, setDownloading] = useState(false);
    const chartEl = useRef();
    let nodata = props.pageStatus || !props.data;

    // let current = props.data?.totalFollowersCount?.curr;
    // let previous = props.data?.totalFollowersCount?.prev;

    let count = props.data?.followers_count;

    const renderDownloadButton = (nodata) => {
        return (
            <Dropdown
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    <Dropdown.Item onClick={downloadCSV}>CSV</Dropdown.Item>
                    <Dropdown.Item onClick={downloadPNG}>PNG</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    const downloadPNG = () => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        setDownloading(true);

        return html2canvas(chartEl.current, { backgroundColor: "#fff" }).then((canvas) => {
            setDownloading(false);
            downloadCanvasWithTitle(canvas, props.widget?.name || "Total Followers");
        });
    };

    const downloadCSV = () => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        let downLoadingData = [];
        downLoadingData.push(["Followers", "Count"]);
        let count = props.data?.followers_count || 0;
        downLoadingData.push(["Total", count]);
        downloadCSVData(downLoadingData, props.widget?.name || "Total Followers");
    };

    const increment = () => {
        if (props.fbSelectedPageIds.length === 1) return;
        let index;
        props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === props.selectedFbPage?.value) index = ind;
        });
        if (index === props.fbSelectedPageIds.length - 1) props.setSelectedFbPage(props.fbSelectedPageIds[0]);
        else props.setSelectedFbPage(props.fbSelectedPageIds[index + 1]);
    };

    const decrement = () => {
        if (props.fbSelectedPageIds.length === 1) return;
        let index;
        props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === props.selectedFbPage?.value) index = ind;
        });
        if (index === 0) props.setSelectedFbPage(props.fbSelectedPageIds[props.fbSelectedPageIds.length - 1]);
        else props.setSelectedFbPage(props.fbSelectedPageIds[index - 1]);
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    isFacebook
                    name={props.widget?.name || "Total Followers"}
                    info="Total number of followers count on your page. Date range filter is not applicable for this chart."
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isFBPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget?.name}
                            />
                        )}
                    {!props.isPublic && !props.isResearchDashboard && !nodata && <>{renderDownloadButton(nodata)}</>}
                    {(props.isPublic && nodata) || props.isFBPage ? null : (
                        <Popup
                            className="skiptranslate"
                            trigger={
                                props.expand ? (
                                    <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                ) : (
                                    <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                )
                            }
                            inverted
                            content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                            size="mini"
                            position="bottom center"
                            style={{ zIndex: "99999" }}
                        />
                    )}
                    {(!props.isPublic && nodata) || props.isFBPage ? null : (
                        <MoreOptions
                            className={nodata && props.isFBPage ? "pointer-disabled" : "more-options"}
                            onClick={(e) => props.changeShowMoreOptions(e)}
                        />
                    )}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {/* {!nodata && (
                        <>
                            <FBIntervalSelector
                                aggs_val={props.aggs_val}
                                appliedFilter={props.appliedFilter}
                                handleIntervalChange={props.handleIntervalChange}
                            />
                        </>
                    )} */}
                    {!props.isFBPage &&
                        !props.isPublic &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                                <DeleteWidget onClick={props.deleteWidget} />
                            </>
                        )}
                </ChartOptionsSidebar>
            )}

            {/* <div className="dashboard-chart dashboard-chart-slider skiptranslate" > */}
            {/* {!props.isFBPage && (
                    <div data-html2canvas-ignore="true" className={`chart-slider chart-slider-left ${props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}>
                        <ArrowIcon onClick={decrement} />
                    </div>
                )} */}

            <div className="chart-area" ref={chartEl}>
                {!props.isFBPage && props.selectedFbPage && (
                    <FBPageSelector
                        selectedFbPage={props.selectedFbPage}
                        setSelectedFbPage={props.setSelectedFbPage}
                        fbSelectedPageIds={props.fbSelectedPageIds}
                        widgetContainerRef={props.widgetContainerRef}
                    />
                )}
                {!nodata ? (
                    <div className="chart__content">
                        {!(downloading || !props.selectedFbPage || props.loading) ? (
                            <>
                                <div className="followers__count">{kFormatter(count)}</div>
                                <div className="chart__text1">Total Followers</div>

                                {/* <div className="zzz">
                                    <div className="chart__text">Followers</div>
                                </div> */}
                            </>
                        ) : (
                            <Loading />
                        )}
                    </div>
                ) : (
                    <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                )}
            </div>

            {/* {!props.isFBPage && (
                    <div data-html2canvas-ignore="true" className={`chart-slider chart-slider-right ${props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}>
                        <ArrowIcon onClick={increment} />
                    </div>
                )} */}
            {/* </div> */}
        </>
    );

    return props.isFBPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}

export default TotalFollowersCount;
